// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper___Hwdz","truncatedText":"styles_truncatedText__MwaKU","fullText":"styles_fullText__C2AqI","textContainer":"styles_textContainer__0eNXj"};